import axios from 'axios'
import { BUSCAR_MAPA_VIAGEM } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarMapaViagem (idItinerario, idEmpresa) {
  const url = `${URL}/itinerario/${idItinerario}/empresa/${idEmpresa}/mapa-viagem`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_MAPA_VIAGEM,
        payload: response

      })
  );
}
